import React from 'react';
import {
  Box, Typography, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton
} from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import RichTextEditor from './RichTextEditor';

export function AddBlogDialog({
  open,
  onClose,
  blogTitle,
  setBlogTitle,
  blogContent,
  setBlogContent,
  blogError,
  blogSubmitting,
  onAdd,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, #0D004A 0%, #1a0a6e 100%)', color: 'white', py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ArticleIcon />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Add AiroNote</Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 4 }}>
        <TextField label="Title" value={blogTitle} onChange={e => setBlogTitle(e.target.value)} fullWidth sx={{ mt: 1, mb: 3 }} disabled={blogSubmitting} />
        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#666' }}>Content</Typography>
        <Box sx={{ mb: 2 }}>
          <RichTextEditor value={blogContent} onChange={setBlogContent} placeholder="Enter AiroNote content..." />
        </Box>
        {blogError && (
          <Typography variant="body2" color="error" sx={{ mb: 1 }}>{blogError}</Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, px: 4 }}>
        <Button onClick={onClose} disabled={blogSubmitting} sx={{ borderRadius: 2, textTransform: 'none' }}>Cancel</Button>
        <Button onClick={onAdd} variant="contained" disabled={blogSubmitting} sx={{ bgcolor: '#0D004A', '&:hover': { bgcolor: '#1a0a6e' }, borderRadius: 2, textTransform: 'none' }}>
          {blogSubmitting ? 'Adding…' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function EditBlogDialog({
  open,
  onClose,
  editBlogTitle,
  setEditBlogTitle,
  editBlogContent,
  setEditBlogContent,
  blogError,
  blogSubmitting,
  onSave,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, #0D004A 0%, #1a0a6e 100%)', color: 'white', py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EditIcon />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Edit AiroNote</Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 4 }}>
        <TextField label="Title" value={editBlogTitle} onChange={e => setEditBlogTitle(e.target.value)} fullWidth sx={{ mb: 3 }} disabled={blogSubmitting} />
        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#666' }}>Content</Typography>
        <Box sx={{ mb: 2 }}>
          <RichTextEditor value={editBlogContent} onChange={setEditBlogContent} placeholder="Enter AiroNote content..." />
        </Box>
        {blogError && (
          <Typography variant="body2" color="error" sx={{ mb: 1 }}>{blogError}</Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, px: 4 }}>
        <Button onClick={onClose} disabled={blogSubmitting} sx={{ borderRadius: 2, textTransform: 'none' }}>Cancel</Button>
        <Button onClick={onSave} variant="contained" disabled={blogSubmitting} sx={{ bgcolor: '#0D004A', '&:hover': { bgcolor: '#1a0a6e' }, borderRadius: 2, textTransform: 'none' }}>
          {blogSubmitting ? 'Saving…' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddBlogDialog;
